
seedWebApp.controller('ContactsController', ['$scope', '$rootScope', 'ContactService', '$uibModal', 'ToastService', 'TranslationService', 'StoreService', function ($scope, $rootScope, ContactService, $uibModal, ToastService, TranslationService, StoreService) {

    $scope.translation = TranslationService.getActiveTranslation();

    $scope.prefs = {
        name: 'ContactsGrid',
        sortByCol: null,
        canAdd: false,
        canEdit: true,
        canDelete: false,
        postProcessing: function (items) {
            for (var i in items) {
                if (!items[i].StockType) {
                    items[i].StockType = 'N';
                }
            }
        }
    };

    $scope.getFlag = function (country) {
        return '../Images/flags/' + country + '.png';
    };

    $scope.contactClass = function (item) {        
        return 'agp-color';        
    };

    $scope.columns = [
        { name: 'TraderUserID', display: 'Trader', dataType: 'avatar', width: 1, filterOptions: [] },
        { name: 'ContactID', display: 'ID', orderBy: 'asc', filterOptions: [], editable: false, width: 10, isKey: true, customClass: $scope.contactClass },
        { name: 'ContactCode', display: 'Código', filterOptions: [], editable: false, width: 15},
        { name: 'ContactName', display: $scope.translation.Client, filterOptions: [], editable: true, width: 45 },
        { name: 'ContactTypeID', display: $scope.translation.Type, filterOptions: [], editable: true, width: 5 },
        { name: 'ContactGroupID', display: $scope.translation.ContactGroup, filterOptions: [], editable: true, width: 5 },
        { name: 'CountryID', display: $scope.translation.Country, isRequired: true, getFlag: $scope.getFlag, filterOptions: [], editable: true, width: 5 },
        { name: 'ShipCity', display: $scope.translation.ShipCity, isRequired: true, filterOptions: [], editable: true, width: 5 },
        { name: 'ShipState', display: $scope.translation.ShipState, isRequired: true, filterOptions: [], editable: true, width: 5 },
    ];

    $scope.prefs.sortByCol = $scope.columns[0];
    $scope.prefs.sortByCol.orderReverse = false;

    $scope.prefs.customEdit = function (contact) {
        if (!contact) {
            contact = { ContactID: 'ADD_NEW' };
        } else {
            contact.BlockedDate = new Date(contact.BlockedDate);
            contact.CertificateExpirationDate = new Date(contact.CertificateExpirationDate);
        }
        var modalInstance = $uibModal.open({
            templateUrl: '/SPA/Contacts/EditContactsModal.html' + seedWebApp.buildVersion,
            controller: 'EditContactsModalController',
            size: 'lg',
            resolve: {
                contact: function () {
                    return contact;
                }
            }
        });
        modalInstance.result.then(function (contact) {
            var toastID = ToastService.createToast('Salvando...', '', 4000, 'wait');

            console.log('saving contact');
            console.log(contact);

            if (!contact.ProjectMode)
                contact.ProjectMode = null;

            if (contact != $scope.contact) {
                ContactService.saveContact(contact).then(
                    function (response) {
                        ToastService.removeToast(toastID);
                        ToastService.createToast('Preferências atualizadas com sucesso', '', 2000, 'success');
                        StoreService.resetCache();
                        $scope.doRefresh();
                    },
                    function (error) {
                        ToastService.removeToast(toastID);
                        ToastService.createToast('Erro', error.data.ExceptionMessage, 2000, 'error');
                    }
                );
            }
        });
    };

    $scope.loadColumns = ContactService.getContactsColumns;
    $scope.loadService = ContactService.getContacts;
    $scope.resetService = ContactService.resetCache;

    $scope.getTotal = function () {
        $scope.loadingTotal = true;
        ContactService.getContactsCount().then(function (response) {
            $scope.loadingTotal = false;
            if (response) {
                $scope.totalItems = response.data.TotalCount;
                $scope.lastSync = response.data.LastSync;
            }
            
        });
    };

    $scope.getTotal();

    $scope.searchMode = function () {
        $scope.$broadcast('inputSearch', $scope.filterString);
    };

    $scope.doRefresh = function () {
        $scope.$broadcast('refreshServiceGrid');
    };

    $scope.toExcel = function () {
        $scope.$broadcast('toExcel', 'Clientes');
    };

    $scope.doInsert = function () {
        $scope.$broadcast('addItem');
    };

    $scope.updateCounters = function () {
        ContactService.resetCache();
        $scope.loading = true;
        StoreService.updateContactCounters().then(function () {
            $scope.loading = false;
        });
    };

    //$(document).ready(function () {
    //    $scope.overflowSize = $scope.AdjustSize();
    //});


}]);
